var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showModal
    ? _c(
        "div",
        {
          staticClass: "newsletter-form-container",
          attrs: { id: "background" },
          on: {
            click: function($event) {
              return _vm.closeNewsletterModal($event)
            }
          }
        },
        [
          _c("div", { staticClass: "newsletter-modifier-container" }, [
            _c(
              "div",
              { staticClass: "newsletter-form-content" },
              [
                _c("div", { staticClass: "input-container input-select" }, [
                  _c("label", { attrs: { for: "platform" } }, [
                    _vm._v(
                      _vm._s(
                        `${_vm.$t(
                          "controlPanel.landingPage.selectPlatformForm"
                        )}`
                      )
                    )
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newsletter.platform,
                              expression: "newsletter.platform"
                            }
                          ],
                          attrs: { id: "platform" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.newsletter,
                                "platform",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "DRC" } }, [
                            _vm._v("DRC")
                          ]),
                          _c("option", { attrs: { value: "GOP" } }, [
                            _vm._v("GOP")
                          ])
                        ]
                      ),
                      _c("Hint", {
                        attrs: {
                          label: "",
                          hint: `${_vm.$t(
                            "controlPanel.landingPage.selectHintForm"
                          )}`
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("NewsletterInputText", {
                  attrs: {
                    newsletter: _vm.newsletter,
                    field: `topic`,
                    placeholder: `${_vm.$t(
                      "controlPanel.landingPage.exampleTopic"
                    )}`,
                    hint: `${_vm.$t(
                      "controlPanel.landingPage.commonHintForm",
                      _vm.NewsletterFormService.validations.topic
                    )}`,
                    label: `${_vm.$t("controlPanel.landingPage.topicForm")}`,
                    validations: _vm.NewsletterFormService.validations.topic
                  }
                }),
                _c("NewsletterInputText", {
                  attrs: {
                    newsletter: _vm.newsletter,
                    field: `title`,
                    placeholder: `${_vm.$t(
                      "controlPanel.landingPage.exampleTitle"
                    )}`,
                    hint: `${_vm.$t(
                      "controlPanel.landingPage.commonHintForm",
                      _vm.NewsletterFormService.validations.title
                    )}`,
                    label: `${_vm.$t("controlPanel.landingPage.titleForm")}`,
                    validations: _vm.NewsletterFormService.validations.title
                  }
                }),
                _c("NewsletterInputText", {
                  attrs: {
                    newsletter: _vm.newsletter,
                    field: `message`,
                    placeholder: `${_vm.$t(
                      "controlPanel.landingPage.exampleMessage"
                    )}`,
                    hint: `${_vm.$t(
                      "controlPanel.landingPage.commonHintForm",
                      _vm.NewsletterFormService.validations.message
                    )}`,
                    label: `${_vm.$t("controlPanel.landingPage.messageForm")}`,
                    validations: _vm.NewsletterFormService.validations.message
                  }
                }),
                _c("NewsletterInputText", {
                  attrs: {
                    newsletter: _vm.newsletter,
                    field: `redirectionButtonText`,
                    placeholder: `${_vm.$t(
                      "controlPanel.landingPage.exampleButtonRedirect"
                    )}`,
                    hint: `${_vm.$t(
                      "controlPanel.landingPage.commonHintForm",
                      _vm.NewsletterFormService.validations
                        .redirectionButtonText
                    )}`,
                    label: `${_vm.$t(
                      "controlPanel.landingPage.redirectButtonForm"
                    )}`,
                    validations:
                      _vm.NewsletterFormService.validations
                        .redirectionButtonText
                  }
                }),
                _c("NewsletterInputText", {
                  attrs: {
                    newsletter: _vm.newsletter,
                    field: `redirectUrl`,
                    placeholder: `https://www.example.com`,
                    hint: `${_vm.$t(
                      "controlPanel.landingPage.redirectButtonHintForm",
                      _vm.NewsletterFormService.validations.redirectUrl
                    )}`,
                    label: `${_vm.$t(
                      "controlPanel.landingPage.redirectButtonUrlForm"
                    )}`,
                    validations:
                      _vm.NewsletterFormService.validations.redirectUrl
                  }
                }),
                _c("NewsletterTemplate", {
                  attrs: { newsletter: _vm.newsletter }
                })
              ],
              1
            ),
            _c("div", { staticClass: "newsletter-form-buttons" }, [
              _c(
                "button",
                {
                  class: ["save", { disabled: !_vm.noErrors() }],
                  on: {
                    click: function($event) {
                      return _vm.saveNewsletter($event)
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.$t("controlPanel.landingPage.buttons.save")}`
                      ) +
                      " "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { id: "button-close" },
                  on: {
                    click: function($event) {
                      return _vm.closeNewsletterModal($event)
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.$t("controlPanel.landingPage.buttons.close")}`
                      ) +
                      " "
                  )
                ]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }